import gql from 'graphql-tag';
import graphqlClient from '../helpers/graphqlClient';

export default new (class {
	async getAll() {
		const { data } = await graphqlClient.query({
			query: gql`
				{
					avatars {
						id
						description
						smallImageBase64
						largeImageBase64
					}
				}
			`,

			fetchPolicy: 'no-cache'
		});

		return data.avatars;
	}

	async getUserAvatar(studentId) {
		const { data } = await graphqlClient.query({
			query: gql`
                {
                    students(where: "id=${studentId}") {
                        avatar {
                            largeImageBase64
                        }
                    }
                }
            `,

			fetchPolicy: 'no-cache'
		});

		if (data.students.length) {
			return data.students[0].avatar.largeImageBase64;
		}

		return null;
	}

	async updateUserAvatar(studentId, avatarId) {
		const response = await graphqlClient.mutate({
			mutation: gql`
				mutation($update: StudentInputObjectGraphType!) {
					updateIgnoreNullValuesStudent(update: $update) {
						id
					}
				}
			`,
			variables: {
				update: {
					id: studentId,
					avatarId: avatarId
				}
			}
		});

		return response.data;
	}
})();
